import { MinzeElement } from 'minze'

export interface LvcChevronLeftIcon {}

export class LvcChevronLeftIcon extends MinzeElement {
  html = () => `
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.5674 13.4999C9.84262 12.0421 7.86137 10.4377 6.07223 8.69768C5.70487 8.34042 5.68061 7.76008 6.01925 7.37548C7.61963 5.55793 9.2112 4.20267 11.4063 2.49994" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  
  `

  css = () => `
    
  `
}
